export const aboutListText = {
  peopleText:
    "Nous disposons d'une équipe de professionnels expérimentés qui s'attachent à fournir un excellent service à nos clients.",
  bookText: `Nous avons fait nos preuves, avec de nombreux clients satisfaits.`,
  clipboardText:
    'Nous offrons une large gamme de services pour répondre aux besoins uniques de nos clients',
  microchipText: `Nous utilisons les dernières technologies et stratégies de marketing pour nous assurer que les biens de nos clients sont vus par les bonnes personnes.`,
  handshakeText: `Nous fournissons une assistance juridique afin de garantir que toutes les transactions se déroulent sans heurts et de manière efficace.`,
};